import React from 'react';
interface StepLinkProps {
  link: string;
  name: string;
  onChange: (patch: {
    link?: string;
    name?: string;
  }) => void;
}
export function StepLink({
  link,
  name,
  onChange
}: StepLinkProps) {
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-8" data-id="element-2561">
      <div data-id="element-2562">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2563">
          Linkul anunțului
        </h2>
        <p className="text-sm text-light-3" data-id="element-2564">
          OLX, Storia, Imobiliare sau orice altă platformă. Linkul scapă
          chiriașul de a întreba detalii.
        </p>
      </div>

      <div data-id="element-2565">
        <label className="block text-xs font-medium text-light-3 uppercase tracking-wider mb-2" data-id="element-2566">
          Link către anunț <span className="text-lime-1" data-id="element-2567">*</span>
        </label>
        <input type="url" value={link} onChange={e => onChange({
        link: e.target.value
      })} placeholder="https://www.olx.ro/..." autoFocus className="w-full h-12 px-4 rounded-xl bg-dark-2 border border-dark-4 text-base text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2568" />
      </div>

      <div data-id="element-2569">
        <label className="block text-xs font-medium text-light-3 uppercase tracking-wider mb-2" data-id="element-2570">
          Nume scurt{' '}
          <span className="text-light-4 font-normal normal-case" data-id="element-2571">
            (opțional)
          </span>
        </label>
        <input type="text" value={name} onChange={e => onChange({
        name: e.target.value
      })} placeholder="ex. Cotroceni · 2 camere" className="w-full h-12 px-4 rounded-xl bg-dark-2 border border-dark-4 text-base text-light-1 placeholder:text-light-4 focus:outline-none focus:border-lime-1 transition-colors" data-id="element-2572" />
        <p className="text-xs text-light-4 mt-2" data-id="element-2573">
          Te ajută să recunoști rapid proprietatea în lista ta. Dacă lași gol,
          completăm noi.
        </p>
      </div>
    </div>;
}